<template>
    <div>

        <div class="tw-flex tw-w-full">
            <div class="tw-w-1/3 mr-2">
                <website-content-base-due
                    :constants="constants"
                    :baseDues="baseDues"
                    class="tw-p-4 tw-border tw-rounded-lg tw-border-gray-200 tw-mb-2"
                ></website-content-base-due>
            </div>

            <div class="tw-w-2/3 mr-2">
                <website-content-maps
                    class="tw-p-4 tw-border tw-rounded-lg tw-border-gray-200 tw-mb-2"
                ></website-content-maps>
            </div>
        </div>

        <div class="tw-flex tw-w-full">
            <div class="tw-w-1/2 mr-2">
                <website-content-production-report-667
                    class="tw-p-4 tw-border tw-rounded-lg tw-border-gray-200 tw-mb-2"
                ></website-content-production-report-667>
            </div>

            <div class="tw-w-1/2 mr-2">
                <website-content-trainee
                    :constants="constants"
                    :contents="contents"
                    class="tw-p-4 tw-border tw-rounded-lg tw-border-gray-200 tw-mb-2"
                ></website-content-trainee>
            </div>
        </div>
            <div class="tw-flex tw-w-full">
                <div class="tw-w-1/2 mr-2">
                    <website-content-production-report-669
                        class="tw-p-4 tw-border tw-rounded-lg tw-border-gray-200 tw-mb-2"
                    ></website-content-production-report-669>
                </div>
                <div class="tw-w-1/2">
                    <website-content-wallet-card
                        class="tw-p-4 tw-border tw-rounded-lg tw-border-gray-200 tw-mb-2"
                    ></website-content-wallet-card>
                </div>
        </div>

        <website-content-links
            class="tw-p-4 tw-border tw-rounded-lg tw-border-gray-200 tw-mb-2"
            :linkCategories="linkCategories"
        ></website-content-links>

        <website-content-committees
            class="tw-p-4 tw-border tw-rounded-lg tw-border-gray-200 tw-mb-2"
        ></website-content-committees>

        <website-content-contracts
            class="tw-p-4 tw-border tw-rounded-lg tw-border-gray-200 tw-mb-2"
            :constants="constants"
            :contents="contents"
        ></website-content-contracts>

        <website-content-letter-contents
            class="tw-p-4 tw-border tw-rounded-lg tw-border-gray-200 tw-mb-2"
            :constants="constants"
            :contents="contents"
        ></website-content-letter-contents>

        <website-content-marketplace-contents
            class="tw-p-4 tw-border tw-rounded-lg tw-border-gray-200 tw-mb-2"
            :constants="constants"
            :contents="contents"
        ></website-content-marketplace-contents>

    </div>
</template>

<script>
import WebsiteContentContracts from "@/Pages/InternalPages/WebsiteContentManagement/WebsiteContentContracts";
import WebsiteContentCommittees from "@/Pages/InternalPages/WebsiteContentManagement/WebsiteContentCommittees";
import WebsiteContentWalletCard from "@/Pages/InternalPages/WebsiteContentManagement/WebsiteContentWalletCard"
import WebsiteContentProductionReport667 from "@/Pages/InternalPages/WebsiteContentManagement/WebsiteContentProductionReport667"
import WebsiteContentTrainee from "@/Pages/InternalPages/WebsiteContentManagement/WebsiteContentTrainee"
import WebsiteContentBaseDue from "@/Pages/InternalPages/WebsiteContentManagement/WebsiteContentBaseDue"
import WebsiteContentMaps from "@/Pages/InternalPages/WebsiteContentManagement/WebsiteContentMaps"
import WebsiteContentLinks from "@/Pages/InternalPages/WebsiteContentManagement/WebsiteContentLinks";
import WebsiteContentProductionReport669 from "@/Pages/InternalPages/WebsiteContentManagement/WebsiteContentProductionReport669"
import WebsiteContentLetterContents from "@/Pages/InternalPages/WebsiteContentManagement/WebsiteContentLetterContents"
import WebsiteContentMarketplaceContents from "@/Pages/InternalPages/WebsiteContentManagement/WebsiteContentMarketplaceContents.vue"

export default {
    name: "WebsiteContentMembers",
    components: {
        WebsiteContentMarketplaceContents,
        WebsiteContentContracts,
        WebsiteContentCommittees,
        WebsiteContentWalletCard,
        WebsiteContentProductionReport667,
        WebsiteContentProductionReport669,
        WebsiteContentTrainee,
        WebsiteContentBaseDue,
        WebsiteContentMaps,
        WebsiteContentLinks,
        WebsiteContentLetterContents,
    },
    props: {
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'contents': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'baseDues': {
            type: String,
            required: false,
            default: function() {
                return ''
            }
        },
        'linkCategories': {
            // Only specified at source parent component
        },

    },
    data() {
        return {

        }
    },
    mounted() {
        //
    },
    computed: {

    },
    methods: {
        //
    }
}
</script>
<style scoped>
.description {
    font-size: 0.9em;
}
</style>
